import React, { useState, useEffect } from 'react';
import { Mail, Phone, Menu, X } from 'lucide-react';
import { siteInfo } from '../mock';

// ⭐ YOUR LOGO IMPORT (assets folder से)
import logo from "../assets/Ayush-SPA-Photoroom.png";

const Header = ({ setActiveSection }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // ⭐ Dropdown State
  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Top Bar */}
      <div className="bg-gradient-to-r from-amber-900 to-amber-800 text-white py-2">
        <div className="container mx-auto px-4 flex justify-between items-center text-sm">
          <a
            href={`mailto:${siteInfo.email}`}
            className="flex items-center gap-2 hover:text-amber-200 transition-colors"
          >
            <Mail size={16} />
            <span className="hidden sm:inline">{siteInfo.email}</span>
          </a>
          <a
            href={`tel:${siteInfo.phone}`}
            className="flex items-center gap-2 hover:text-amber-200 transition-colors"
          >
            <Phone size={16} />
            <span>{siteInfo.phone}</span>
          </a>
        </div>
      </div>

      {/* Main Navigation */}
      <nav
        className={`sticky top-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-black/40 shadow-lg' : 'bg-black/20 backdrop-blur-sm'
          }`}
      >
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center h-20">
            <div
              className="flex flex-col items-center cursor-pointer"
              onClick={() => setActiveSection('home')}
            >
              <img
                src={logo}
                alt="Aayush Spa Logo"
                className="h-24 w-24 object-contain drop-shadow-lg"
              />
            </div>
            <div className="hidden md:flex items-center gap-8">
              <button
                onClick={() => setActiveSection('home')}
                className="text-white hover:text-amber-900 transition-colors font-medium"
              >
                Home
              </button>
              <button
                onClick={() => setActiveSection('about')}
                className="text-white hover:text-amber-900 transition-colors font-medium"
              >
                About
              </button>
              <div
                className="relative pb-0"   // ⭐ Stable dropdown fix
                onMouseEnter={() => setDropdownOpen(true)}
                onMouseLeave={() => setDropdownOpen(false)}
              >
                <button
                  className="text-white hover:text-amber-900 transition font-medium flex items-center gap-1"
                >
                  Services <span className="text-lg">+</span>
                </button>

                {dropdownOpen && (
                  <div
                    className="absolute top-8 left-0 bg-white/95 backdrop-blur-xl border border-amber-200 shadow-2xl rounded-xl w-64 py-3 z-50"
                  >
                    <ul className="text-gray-800">

                      <li
                        onClick={() => { setActiveSection('thai'); setDropdownOpen(false); }}
                        className="px-4 py-2 hover:bg-amber-100 rounded-lg cursor-pointer transition"
                      >
                        Thai Dry Massage
                      </li>
                      <li
                        onClick={() => { setActiveSection('aroma'); setDropdownOpen(false); }}
                        className="px-4 py-2 hover:bg-amber-100 rounded-lg cursor-pointer transition"
                      >
                        Aroma Massage
                      </li>
                      <li
                        onClick={() => { setActiveSection('swedish'); setDropdownOpen(false); }}
                        className="px-4 py-2 hover:bg-amber-100 rounded-lg cursor-pointer transition"
                      >
                        Swedish Massage
                      </li>
                      <li
                        onClick={() => { setActiveSection('balinese'); setDropdownOpen(false); }}
                        className="px-4 py-2 hover:bg-amber-100 rounded-lg cursor-pointer transition"
                      >
                        Balinese Massage
                      </li>
                      <li
                        onClick={() => { setActiveSection('deep'); setDropdownOpen(false); }}
                        className="px-4 py-2 hover:bg-amber-100 rounded-lg cursor-pointer transition"
                      >
                        Deep Tissue Massage
                      </li>

                      <li
                        onClick={() => { setActiveSection('scrub'); setDropdownOpen(false); }}
                        className="px-4 py-2 hover:bg-amber-100 rounded-lg cursor-pointer transition"
                      >
                        Body Scrub
                      </li>
                    </ul>
                  </div>
                )}
              </div>

              <button
                onClick={() => setActiveSection('gallery')}
                className="text-white hover:text-amber-900 transition-colors font-medium"
              >
                Gallery
              </button>

              <button
                onClick={() => setActiveSection('contact')}
                className="text-white hover:text-amber-900 transition-colors font-medium"
              >
                Contact Us
              </button>

              <button
                onClick={() => setActiveSection('booking')}
                className="bg-amber-900 text-white px-6 py-2.5 rounded-md hover:bg-amber-800 transition-colors font-medium"
              >
                Book Now
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden text-white"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>

          {/* Mobile Menu */}
          {isMobileMenuOpen && (
            <div className="md:hidden py-4 border-t">
              <div className="flex flex-col gap-4">

                <button
                  onClick={() => { setActiveSection('home'); setIsMobileMenuOpen(false); }}
                  className="text-white hover:text-amber-900 transition-colors font-medium text-left"
                >
                  Home
                </button>

                <button
                  onClick={() => { setActiveSection('about'); setIsMobileMenuOpen(false); }}
                  className="text-white hover:text-amber-900 transition-colors font-medium text-left"
                >
                  About
                </button>

                <button
                  onClick={() => { setActiveSection('services'); setIsMobileMenuOpen(false); }}
                  className="text-white hover:text-amber-900 transition-colors font-medium text-left"
                >
                  Services
                </button>
                <button
                  onClick={() => { setActiveSection('gallery'); setIsMobileMenuOpen(false); }}
                  className="text-white hover:text-amber-900 transition-colors font-medium text-left"
                >
                  Gallery
                </button>
                <button
                  onClick={() => { setActiveSection('contact'); setIsMobileMenuOpen(false); }}
                  className="text-white hover:text-amber-900 transition-colors font-medium text-left"
                >
                  Contact Us
                </button>
                <button
                  onClick={() => { setActiveSection('booking'); setIsMobileMenuOpen(false); }}
                  className="bg-amber-900 text-white px-6 py-2.5 rounded-md hover:bg-amber-800 transition-colors font-medium"
                >
                  Book Now
                </button>

              </div>
            </div>
          )}
        </div>
      </nav>
    </>
  );
};

export default Header;
